import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../i18n";

const About = () => {
  const { t } = useLanguage();
  return (
  <section className="about-section-container" id="about">
    <motion.div
      className="home-section-text-container"
      initial={{ y: 40, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <h2 className="primary-subheading" data-outline={t.about}>
        {t.about}
      </h2>
      <h3 className="primary-heading">Pranesh Enterprises</h3>
      <p className="primary-text">
        {t.aboutText1}
      </p>
      <p className="primary-text">
        {t.aboutText2}
      </p>
    </motion.div>
  </section>
  );
};

export default About;
